import { Application } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"
import './util.js'

import { registerCommonControllers } from '@foxhound-systems/yesod-ui/controllers';
import { AWSPresignedPostController } from './controllers/aws_presigned_post_controller.js';
import { GoogleAddressAutoCompleteController } from './controllers/google_address_autocomplete_controller.js';
import { IdleRedirectController } from './controllers/idle_redirect_controller.js';
import { SmsPollController } from './controllers/sms_poll_controller.js';
import { SmsFeedController } from './controllers/sms_feed_controller.js';
import { SmsActivityController } from './controllers/sms_activity_controller.js';
import { RelativeTimeController } from './controllers/relative_time_controller.js';
import { ShopifyPanelController } from './controllers/shopify_panel_controller.js';
import { SmsWorkspaceController } from './controllers/sms_workspace_controller.js';
import { SmsNavigationController } from './controllers/sms_navigation_controller.js';
import { MessagePreviewController } from './controllers/message_preview_controller.js';
import { ProductImportProgressController } from './controllers/product_import_progress_controller.js';
import { ProductImportSelectionController } from './controllers/product_import_selection_controller.js';
import { FileDropController } from './controllers/file_drop_controller.js';
import { EmailInputController } from './controllers/email_input_controller.js';
import { PrettyJsonController } from './controllers/pretty_json_controller.js';
import { DesignPaletteController } from './controllers/design_palette_controller.js';

(() => {
    const application = Application.start()
    registerCommonControllers(application);
    application.register("aws-presigned-post", AWSPresignedPostController);
    application.register("google-address-autocomplete", GoogleAddressAutoCompleteController);
    application.register("idle-redirect", IdleRedirectController);
    application.register("sms-poll", SmsPollController);
    application.register("sms-feed", SmsFeedController);
    application.register("sms-activity", SmsActivityController);
    application.register("relative-time", RelativeTimeController);
    application.register("shopify-panel", ShopifyPanelController);
    application.register("sms-workspace", SmsWorkspaceController);
    application.register("sms-navigation", SmsNavigationController);
    application.register("message-preview", MessagePreviewController);
    application.register("product-import-progress", ProductImportProgressController);
    application.register("product-import-selection", ProductImportSelectionController);
    application.register("file-drop", FileDropController);
    application.register("pretty-json", PrettyJsonController);
    application.register("email-input", EmailInputController);
    application.register("design-palette", DesignPaletteController);

    DEV: import("@foxhound-systems/annotato/stimulus").then(({ AnnotatoController }) => {
        application.register("annotato", AnnotatoController);
    });
})()
